module.exports = __webpack_public_path__ + "static/media/calendar.f9ce8b76.svg";